import { translateFormatter, type MessageFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
const messages: Record<string, MessageFormatter<{
  linebreak: RichTextFormatter;
}>> = {
  availabilityB2BDesktopPS: translateFormatter<{
    linebreak: RichTextFormatter;
  }>([{
    "type": 0,
    "value": "8am to 6pm from Monday to Friday"
  }], undefined, undefined, "en"),
  availabilityB2CDesktopPS: translateFormatter<{
    linebreak: RichTextFormatter;
  }>([{
    "type": 0,
    "value": "8am to 8pm from Monday to Friday"
  }], undefined, undefined, "en"),
  availabilityB2BDesktopAS: translateFormatter<{
    linebreak: RichTextFormatter;
  }>([{
    "type": 0,
    "value": "8am to 6pm from Monday to Friday"
  }], undefined, undefined, "en"),
  availabilityB2CDesktopAS: translateFormatter<{
    linebreak: RichTextFormatter;
  }>([{
    "type": 0,
    "value": "8am to 8pm from Monday to Friday"
  }], undefined, undefined, "en"),
  availabilityB2BMobilePS: translateFormatter<{
    linebreak: RichTextFormatter;
  }>([{
    "type": 0,
    "value": "8am to 6pm from Monday to Friday"
  }], undefined, undefined, "en"),
  availabilityB2CMobilePS: translateFormatter<{
    linebreak: RichTextFormatter;
  }>([{
    "type": 0,
    "value": "8am to 8pm from Monday to Friday"
  }], undefined, undefined, "en"),
  availabilityB2BMobileAS: translateFormatter<{
    linebreak: RichTextFormatter;
  }>([{
    "type": 0,
    "value": "8am to 6pm from Monday to Friday"
  }], undefined, undefined, "en"),
  availabilityB2CMobileAS: translateFormatter<{
    linebreak: RichTextFormatter;
  }>([{
    "type": 0,
    "value": "8am to 8pm from Monday to Friday"
  }], undefined, undefined, "en")
};
export default messages;